/**
 * Created by rossd on 6/12/2018.
 */
import createReducer from "../lib/createReducer";
import * as types from "../actions/types"

export const selectedOrganisation = createReducer({},{
    [types.SET_SELECTED_ORG](state,action){
        return action.payload
    }
})


// WEBPACK FOOTER //
// ./src/reducers/user.js